<div class="status-container">
  <!-- to show the report/status of after uploading CSV -->
  <ng-container *ngIf="data.category == 'csv-upload'">
    <div class="status-info text-center">
      <h4 class="text-center">{{message}}</h4>
      
      <!-- Display counts summary -->
      <div class="upload-summary mt-15 mb-20" *ngIf="totalCount > 0 && isCarrier">
        <div class="summary-row">
          <span class="summary-label">Total Records:</span>
          <span class="summary-value">{{totalCount}}</span>
        </div>
        <div class="summary-row" *ngIf="successCount > 0">
          <span class="summary-label success-text">Successfully Processed:</span>
          <span class="summary-value success-text">{{successCount}}</span>
        </div>
        <!-- <div class="summary-row" *ngIf="validationSuccessCount > 0">
          <span class="summary-label success-text">Validation Passed:</span>
          <span class="summary-value success-text">{{validationSuccessCount}}</span>
        </div> -->
        <div class="summary-row" *ngIf="failedCount > 0">
          <span class="summary-label error-text">Upload Failed:</span>
          <span class="summary-value error-text">{{failedCount}}</span>
        </div>
        <div class="summary-row" *ngIf="validationFailedCount > 0">
          <span class="summary-label error-text">Validation Failed:</span>
          <span class="summary-value error-text">{{validationFailedCount}}</span>
        </div>
        
      </div>
      
      <!-- Error details table -->
      <div class="table-scroll table-hover mt-25" *ngIf="statusData && statusData.length > 0">
        <h5 class="error-details-title">Error Details:</h5>
        <table class="table">
          <thead>
            <tr>
              <th>{{isCarrier? 'Carrier Code': isAction ?  'Action' :  isStore ? 'Store ID' :  'Email Id'}}</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let error of statusData">
              <td>{{error.id}}</td>
              <td>{{error.message}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div class="button-container mt-20">
        <button type="button" class="btn-status mr-10" (click)="closeModal('close')">Okay</button>
        <button type="button" class="btn-status" *ngIf="statusData && statusData.length > 0"
          (click)="closeModal('download')">Download Error Report</button>
      </div>
    </div>
  </ng-container>
</div>